var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 2C24 2 6 7.1 6 8V26.2C6 35.4 19.3 43.5 23 45.7C23.296 45.8978 23.644 46.0033 24 46.0033C24.356 46.0033 24.704 45.8978 25 45.7C28.8 43.6 42 35.4 42 26.2V8C42 7.1 24 2 24 2ZM24 10C25.5823 10 27.129 10.4692 28.4446 11.3482C29.7602 12.2273 30.7855 13.4767 31.391 14.9385C31.9965 16.4003 32.155 18.0089 31.8463 19.5607C31.5376 21.1126 30.7757 22.538 29.6569 23.6569C28.538 24.7757 27.1126 25.5376 25.5607 25.8463C24.0089 26.155 22.4003 25.9965 20.9385 25.391C19.4767 24.7855 18.2273 23.7602 17.3482 22.4446C16.4692 21.129 16 19.5823 16 18C16 15.8783 16.8429 13.8434 18.3431 12.3431C19.8434 10.8429 21.8783 10 24 10ZM24 41.6C21.0106 39.8412 18.1976 37.7984 15.6 35.5C21.0219 33.5026 26.9781 33.5026 32.4 35.5C29.8464 37.8527 27.0274 39.8998 24 41.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_1440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffManagement);
export default __webpack_public_path__ + "static/media/staffManagement.ea5b4fa2f9169236ffd0f22b4943ae98.svg";
export { ForwardRef as ReactComponent };